import {Component, OnInit, ElementRef, ViewChild, asNativeElements} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators, FormArray} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import {environment} from "../../environments/environment";
import {ENTER} from '@angular/cdk/keycodes';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {UsefulFunctionsService} from '../useful-functions.service';
import {MatAccordionTogglePosition, MatExpansionPanel} from "@angular/material/expansion";
import {MatDialog} from "@angular/material/dialog";
import {DialogLoaderComponent} from "../dialog-loader/dialog-loader.component"
import {ChipsListComponent} from "../chips-list/chips-list.component";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";

interface SelectElements {
  value: string;
  viewValue: string;
}
interface selectElementsListGroup {
  disabled?: boolean;
  name: string;
  list: SelectElements[];
}

//TODO create as a global interface?
interface chipElement {
  arrayString: string[];
  formArrayName: string;
}

interface arraySelectElementControl {
  ctrl: FormControl;
  possible: selectElementsListGroup[];
  elements: selectElementsListGroup[];
}

const ELEMENT_DATA = [
  "123",
  "456",
  "123",
  "123",
  "123","123","123","123","123","123","123","123","123","123","123","123","123","123","123","123",


];

@Component({
  selector: 'app-products-data',
  templateUrl: './products-data.component.html',
  styleUrls: ['./products-data.component.scss']
})
export class ProductsDataComponent implements OnInit {

  getProductsDataForm = this.fb.group({
    range: this.fb.group({
      startDate: [''/*,  Validators.required*/],
      endDate: ['',  /*Validators.required*/],
    }),
    categories:this.fb.array([]),
    containAtLeastOne: this.fb.group({
      INCIs: this.fb.array([]),
      listsIds: this.fb.array([]),
    }),
    containAll: this.fb.group({
      INCIs: this.fb.array([])
    }),
    exclude: this.fb.group({
      INCIs: this.fb.array([]),
      listsIds: this.fb.array([]),
    }),
    EANs: this.fb.array([]),
    brands: this.fb.array([]),
    metadatas: this.fb.array([]),
    countries: this.fb.array([]),
    analysis: this.fb.group({
      personalList: this.fb.array([]),
      listsIds: this.fb.array([])
    }),
  });

  categories: any = [] //The array that will contains all the categories
  metadatas: any = [] //The array that will contains all the metadatas

  results: any //The JSON object that will contain the results from the request

  //Chips boolean
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER];

  basicSearch = true

  //Element from a chip input form control, we can certainly do a class or interface with it but the @ViewChild is posing problem
  eanCtrl = new FormControl(); //FormControl for the EAN input
  @ViewChild('eanInput') eanInput: ElementRef<HTMLInputElement>;
  eanChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'EANs',
  }

  inciAtLeastOneCtrl = new FormControl(); //FormControl for the At least one INCI
  @ViewChild('inciAtLeastOneInput') inciAtLeastOneInput: ElementRef<HTMLInputElement>;
  atLeastOneChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'containAtLeastOne.INCIs',
  }

  alertListAtLeastOneCtrl = new FormControl(); //FormControl for the EAN input
  @ViewChild('alertListAtLeastOneInput') alertListAtLeastOneInput: ElementRef<HTMLInputElement>;
  alertListAtLeastOneChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'containAtLeastOne.listsIds',
  }

  inciAllCtrl = new FormControl(); //FormControl for the All INCI
  @ViewChild('inciAllInput') inciAllInput: ElementRef<HTMLInputElement>;
  allChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'containAll.INCIs',
  }

  inciExcludeCtrl = new FormControl(); //FormControl for the Exclude INCI
  @ViewChild('inciExcludeInput') inciExcludeInput: ElementRef<HTMLInputElement>;
  excludeChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'exclude.INCIs',
  }

  alertListExcludeCtrl = new FormControl(); //FormControl for the Exclude List id
  @ViewChild('alertListExcludeInput') alertListExcludeInput: ElementRef<HTMLInputElement>;
  alertListExcludeChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'exclude.listsIds',
  }

  countriesCtrl = new FormControl(); //FormControl for the countries input
  @ViewChild('countriesInput') countriesInput: ElementRef<HTMLInputElement>;
  countriesChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'countries',
  }

  alertListAnalysisCtrl = new FormControl(); //FormControl for the Exclude List id
  alertListAnalysisInput: ElementRef<HTMLInputElement>;
  //Add the element when he is visible
  @ViewChild('alertListAnalysisInput') set alertListAnalysisInputElement(alertListAnalysisInput: ElementRef) {
    this.redefineViewChildInput(alertListAnalysisInput, this.alertListAnalysisInput)
  }
  alertListAnalysisChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'analysis.listsIds',
  }

  inciAnalysisCtrl = new FormControl(); //FormControl for the Exclude INCI
  inciAnalysisInput: ElementRef<HTMLInputElement>;
  //Add the element when he is visible
  @ViewChild('inciAnalysisInput') set inciAnalysisInputElement(inciAnalysisInput: ElementRef) {
    this.redefineViewChildInput(inciAnalysisInput, this.inciAnalysisInput)
  }
  inciAnalysisChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'analysis.personalList',
  }

  brandsCtrl = new FormControl(); //FormControl for the EAN input
  @ViewChild('brandsInput') brandsInput: ElementRef<HTMLInputElement>;
  brandsChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'brands',
  }

  inputElements = [] //Array that will gather the different input defined as ElementRef

  //Will gather the form result from the alerts list
  alertListGroups: selectElementsListGroup[] = [
    {
      name: 'ReadyMade',
      list: []
    },
    {
      name: 'Hazards',
      list: []
    }
  ]

  //Will gathered the possible alert list available when a user is inputting text
  possibleAlertsLists: selectElementsListGroup[] = [
    {
      name: 'ReadyMade',
      list: []
    },
    {
      name: 'Hazards',
      list: []
    }
  ]

  //Will gather the form result from the countries
  countries: selectElementsListGroup[] = [
    {
      name: 'Groups',
      list: []
    },
    {
      name: 'Countries',
      list: []
    }
  ]

  //Will gathered the possible countries available when a user is inputting text
  possibleCountries: selectElementsListGroup[] = [
    {
      name: 'Groups',
      list: []
    },
    {
      name: 'Countries',
      list: []
    }
  ]

  //Gather the different controls and elements needed for the alerts list and contries chip list
  controlsFilter: arraySelectElementControl[] = [
    {
      ctrl:this.countriesCtrl,
      possible:this.possibleCountries,
      elements: this.countries
    },
    {
      ctrl:this.alertListAtLeastOneCtrl,
      possible:this.possibleAlertsLists,
      elements: this.alertListGroups
    },
    {
      ctrl:this.alertListExcludeCtrl,
      possible:this.possibleAlertsLists,
      elements: this.alertListGroups
    },
    {
      ctrl:this.alertListAnalysisCtrl,
      possible:this.possibleAlertsLists,
      elements: this.alertListGroups
    },
  ]

  //Extension Panel steps
  step = 1;
  eanSelected: boolean = false // Boolean marking if the ean step has been done or not
  countriesSelected: boolean = false // Boolean marking if the countries step has been done or not
  brandsSelected: boolean = false // Boolean marking if the brands step has been done or not
  metadatasSelected: boolean = false // Boolean marking if the step has been done or not
  containsAtLeastOneSelected: boolean = false // Boolean marking if the at least one step has been done or not
  containsAtLeastOneSkip: boolean = false // Boolean marking if the at least one step is skipped or not
  containAllSelected: boolean = false // Boolean marking if the contains all step has been done or not
  containAllSkip: boolean = false // Boolean marking if the contains all step is skipped or not
  excludeSelected: boolean = false // Boolean marking if the exclude step has been done or not
  excludeSkip: boolean = false // Boolean marking if the exclude step is skipped or not
  analysisShowed:boolean = false // Boolean indicating if the analysis has to be showed or not
  analysisSelected:boolean = false // Boolean marking if the analysis step has been done or not


  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  reader = new FileReader(); //Use to read the JSON files from the drag and drop

  limit = 1000 //The max number of products that can be retrieve, not to be changed as defined as 1000 in the API
  skip = 0 //The number of products to not retrieve
  currentMax = 0 //The current highest number of products
  nextSkip = 1000 //The next amount of products that will be retrieved, initialise at a 1000 for visual reason

  notFoundEAN: any = [] //Will gathered the list of EANs not found from the search
  displayEANsNotFound: boolean = false //Boolean indicating if we want to see the EANs not found or not

  displayedColumns: string[] = ['EAN'];

  //Define the paginator when he is displayed as the paginator of the
  @ViewChild(MatPaginator) set paginatorSet(paginator: MatPaginator) {
    this.notFoundEAN.paginator = paginator
  }

  constructor(private fb: FormBuilder,
              public httpClient: HttpClient,
              public usefulFunctionsService: UsefulFunctionsService,
              public dialog: MatDialog,
              public chipListComponent: ChipsListComponent ) {

    // The INCI search from the different inci controller, should be put in a loop
    this.inciAtLeastOneCtrl.valueChanges.subscribe(async (inci: any) => {
      this.usefulFunctionsService.possibleINCIs = await this.usefulFunctionsService.searchIngredients(inci)
    })

    this.inciAllCtrl.valueChanges.subscribe(async (inci: any) => {
      this.usefulFunctionsService.possibleINCIs = await this.usefulFunctionsService.searchIngredients(inci)
    })

    this.inciExcludeCtrl.valueChanges.subscribe(async (inci: any) => {
      this.usefulFunctionsService.possibleINCIs = await this.usefulFunctionsService.searchIngredients(inci)
    })

    this.inciAnalysisCtrl.valueChanges.subscribe(async (inci: any) => {
      this.usefulFunctionsService.possibleINCIs = await this.usefulFunctionsService.searchIngredients(inci)
    })


    //Apply the filter function on the chips inputs
    this.controlsFilter.forEach((arrayControl:arraySelectElementControl) => {
      // Subscribe the FormControl to a watch on the value change
      arrayControl.ctrl.valueChanges.subscribe(async (value: any) => {

        //For each selectElementListGroup we filter the possible values based on the input into the possible selectElementListGroup
        arrayControl.elements.forEach((selectElementListGroup, index) => {
          arrayControl.possible[index].list = value ? this.usefulFunctionsService._filter(value, selectElementListGroup.list) : selectElementListGroup.list
        })
      })
    })
  }

  /**
   * When we enter the page
   * Retrieve the data need from the API (categories, countries,...) and format them as needed for the form
   */
  async ngOnInit(): Promise<void> {


    // Retrieve the categories
    this.categories = await this.httpClient.get(environment.apiUrl+"categoriesAndSubcategories").toPromise()

    //Add the checked attributes to the categories
    this.categories = this.categories.map(cat => {
      cat.checked = false
      cat.subcategories = cat.subcategories.map(subcatName => {
        var subcat = {
          name: subcatName,
          checked: false
        }
        return subcat
      })
      return cat
    })

    var metadatas: any = await this.httpClient.get(environment.apiUrl+"metadata").toPromise()
    /** For later use add: |leave_on_products|rinse_off_products */
    this.metadatas = metadatas.filter(metadata => new RegExp(/vegan|cruelty free/i).test(metadata.metadata_tag))

    //Add the checked attributes to the metadata
    this.metadatas = this.metadatas.map(meta => {
      meta.checked = false
      return meta
    })

    //Retrieve the readymade and hazards lists
    var readymade: any = await this.httpClient.get(environment.apiUrl+"personalAlertsAll").toPromise()
    readymade = this.usefulFunctionsService.sort(readymade,"name",true,false )

    var hazards: any = await this.httpClient.get(environment.apiUrl+"hazard").toPromise()
    hazards = hazards.filter(list => list["locale"] == "en") //Filter out only the chinese lists
    hazards = this.usefulFunctionsService.sort(hazards,"name",true,false )

    //Format the lists to SelectElements so that they can be displayed in the selection input
    this.alertListGroups[0].list = this.usefulFunctionsService.formatArraysToSelectElement(readymade)
    this.possibleAlertsLists[0].list = this.usefulFunctionsService.formatArraysToSelectElement(readymade)
    this.alertListGroups[1].list = this.usefulFunctionsService.formatArraysToSelectElement(hazards)
    this.possibleAlertsLists[1].list = this.usefulFunctionsService.formatArraysToSelectElement(hazards)

    var countries:any = await this.httpClient.get(environment.apiUrl+"getAllCountries").toPromise()
    var areas = await this.httpClient.get(environment.apiUrl+"getAllAreas").toPromise()

    this.countries[0].list = this.usefulFunctionsService.formatArraysToSelectElement(areas)
    this.countries[1].list = this.usefulFunctionsService.formatArraysToSelectElement(countries)
    this.possibleCountries[0].list = this.usefulFunctionsService.formatArraysToSelectElement(areas)
    this.possibleCountries[1].list = this.usefulFunctionsService.formatArraysToSelectElement(countries)

  }

  /**
   * Manage the event change on categories checkboxes
   * @param category, the category object ticked
   * @param event, the change event
   */
  onCategoriesChange(category: any, event) {

    //Get the categories formArray from the formBuilder
    const cats = (this.getProductsDataForm.get('categories') as FormArray);

    category.checked = event.checked

    category.subcategories.forEach(subcat => {
      this.onSubCategoriesChange(subcat, category,event)
    })

    const index = cats.controls.findIndex(x => x.value.id === category._id);

    //If the categories is checked add id to the FormControl else remove it
    if (event.checked) {
      //If the category is not already in add it with all the subcategories
      if (index == -1) {
        cats.push(new FormControl({id:category._id, subcategories: []}));
      } else if (!category.subcategories.every(subcat => subcat.checked)) {
        //If the category is already in remove it and readd it with the all the subcategories
        cats.removeAt(index);
        cats.push(new FormControl({id:category._id, subcategories: []}));
      }
    }

  }

  /**
   * Manage the event change on categories checkboxes
   * @param subcategory, the subcategory object ticked
   * @param category, the category object from which the subcategory belongs to
   * @param event, the change event
   */
  onSubCategoriesChange(subcategory:any,category: any, event) {

    subcategory.checked = event.checked

    //Get the categories formArray from the formBuilder
    const cats = (this.getProductsDataForm.get('categories') as FormArray);
    const indexCategory = cats.controls.findIndex(x => x.value.id === category._id);


    //If the categories is checked add id to the FormControl else remove it
    if (event.checked) {
      if (indexCategory == -1) {
        cats.push(new FormControl({id:category._id, subcategories: [subcategory.name]}));
      } else {
        var indexSubcategory = cats.controls[indexCategory].value.subcategories.indexOf(subcategory.name);
        if (indexSubcategory == -1) cats.controls[indexCategory].value.subcategories.push(subcategory.name);
      }
    } else {
      indexSubcategory = cats.controls[indexCategory].value.subcategories.indexOf(subcategory.name);
      cats.controls[indexCategory].value.subcategories.splice(indexSubcategory, 1);
      //If the subcategory array is empty remove the category
      if (cats.controls[indexCategory].value.subcategories.length == 0) cats.removeAt(indexCategory);
    }
  }

  /**
   * Check if some of the subcategories of the category are selected
   * @param array, the array of object were we check if some have their boolean checked at true
   */
  someChecked(array: any): boolean {
    return array.some(elm => elm.checked) && !array.every(elm => elm.checked)
  }

  /**
   * Check if all the categories are checked
   * @param array, the array of object were we check if all have their boolean checked at true
   */
  allChecked(array: any) : boolean {
    return array.every(elm => elm.checked)
  }

  /**
   * Function that check if all the lists for the analysis have been selected
   */
  allAnalysisListSelected(): boolean {
    return this.possibleAlertsLists.every((alertsListsSelectElementsListGroup:selectElementsListGroup) => {
      return alertsListsSelectElementsListGroup.list.every( alertList => {
        return this.getProductsDataForm.value.analysis.listsIds.includes(alertList.value)
      })
    })
  }

  /**
   * Manage the checkboxes changes for the metadatas
   * @param element, the metadata object ticked
   * @param formArrayControlName, the name of the formArrayControl of the metadata
   * @param event, the change event
   * @param metadataSelected, boolean, indicating whether or not the metadata step should be marked as done
   */
  onChangeMetadataCheckboxes(element: any,formArrayControlName:string, event, metadataSelected:boolean) {
    this.metadatasSelected = metadataSelected
    //Get the categories formArray from the formBuilder
    const formArray = (this.getProductsDataForm.get(formArrayControlName) as FormArray);
    const index = formArray.controls.findIndex(x => x.value === element['metadata_tag']);

    element.checked = event.checked

    //If the categories is checked add id to the FormControl else remove it
    if (event.checked) {
      if (index == -1) formArray.push(new FormControl(element['metadata_tag']));
    } else {
      formArray.removeAt(index);
    }
  }

  /**
   * Manage the add event from a MapChipInput
   * @param event,MatChipInputEvent, the event of adding a chip
   * @param formControl, the formControl linked to the input
   * @param array, the array from the component.ts
   * @param formArrayName, the name of the formArray in the form
   * @param inci, boolean indicating whether we are dealing with an INCI input or not
   * @source: https://material.angular.io/components/chips/api
   */
  add(event: MatChipInputEvent, formControl, array, formArrayName, inci:boolean): void {
    const input = event.input;
    const value = event.value;

    if (formArrayName == 'EANs') this.eanSelected = true
    if (formArrayName == 'brands') this.brandsSelected = true

    this.chipListComponent.addChip(value, null, array, formArrayName, formControl, this.getProductsDataForm, inci)

    // Reset the input value
    if (input) {
      input.value = '';
    }

  }

  /**
   * Manage the add event from a MatAutocompleteSelectedEvent, by adding a chip and the value into the formControl
   * @param event, MatAutocompleteSelectedEvent, the selection event
   * @param formControl, the formControl linked to the input
   * @param array, the array from the component.ts
   * @param formArrayName, the name of the formArray in the form
   * @param inci, boolean indicating whether we are dealing with an INCI input or not
   * @source: https://material.angular.io/components/chips/api
   */
  selected(event: MatAutocompleteSelectedEvent, formControl, array, formArrayName, inci:boolean): void {

    this.inputElements = [this.eanInput, this.countriesInput, this.inciAllInput, this.inciExcludeInput, this.inciAtLeastOneInput, this.alertListAtLeastOneInput, this.alertListExcludeInput] //Pass all the inputs in the array

    const value = inci ? event.option.viewValue: event.option.value;
    const viewValue = event.option.viewValue;

    if (formArrayName == 'countries') this.countriesSelected = true
    if (formArrayName.includes('containAtLeastOne')) this.containsAtLeastOneSelected = true
    if (formArrayName.includes('containAll')) this.containAllSelected = true
    if (formArrayName.includes('exclude')) this.excludeSelected = true
    if (formArrayName.includes('analysis')) this.analysisSelected = true

    //Clean all the inputs value as we cannot select the current input as native element
    this.inputElements.forEach(nativeElement => {
      nativeElement.nativeElement.value = ''
    })

    this.chipListComponent.addChip(value, viewValue, array, formArrayName, formControl, this.getProductsDataForm, inci)
  }


  /**
   * Set the dates as the full range
   */
  public selectFullRange() {
    var rangeGroup = (this.getProductsDataForm.get('range') as FormGroup)
    rangeGroup.setValue({startDate: new Date('2013,01,01'), endDate:new Date()})
    this.nextStep()
  }

  /**
   * Select all the eans
   */
  public selectAllEans() {
    this.eanSelected = true
    // remove all the chips as an empty array means the selection of all
    this.chipListComponent.clearChipElement(this.eanChipElement, this.getProductsDataForm)
    this.nextStep()
  }

  /**
   * Select all the countries
   */
  public selectAllCountries() {
    this.countriesSelected = true
    // remove all the chips as an empty array means the selection of all
    this.chipListComponent.clearChipElement(this.countriesChipElement, this.getProductsDataForm)
    this.nextStep()
  }

  /**
   * Select all the brands
   */
  public selectAllBrands() {
    this.brandsSelected = true
    // remove all the chips as an empty array means the selection of all
    this.chipListComponent.clearChipElement(this.brandsChipElement, this.getProductsDataForm)
    this.nextStep()
  }

  /**
   * Select all the brands
   */
  public skipSelectMetadatas() {
    this.metadatasSelected = true
    //Select all the metadata checkboxes
    this.metadatas.forEach(metadata => {
      this.onChangeMetadataCheckboxes(metadata,'metadatas', {checked:false}, true)
    })
    this.nextStep()
  }

  /**
   * Select all the categories
   */
  public selectAllCategories() {
    this.categories.forEach(cat => {
      this.onCategoriesChange(cat, {checked:true})
    })

    this.nextStep()
  }

  /**
   * Skip the Contains At Least One step
   */
  public skipContainsAtLeastOne() {
    this.containsAtLeastOneSelected = true
    this.containsAtLeastOneSkip = true
    this.chipListComponent.clearChipElement(this.atLeastOneChipElement, this.getProductsDataForm)
    this.chipListComponent.clearChipElement(this.alertListAtLeastOneChipElement, this.getProductsDataForm)

    this.nextStep()
  }

  /**
   * Skip the Contains All step
   */
  public skipContainsAll() {
    this.containAllSelected = true
    this.containAllSkip = true
    this.chipListComponent.clearChipElement(this.allChipElement, this.getProductsDataForm)
    this.nextStep()
  }

  /**
   * Skip the Exclude step
   */
  public skipExclude() {
    this.excludeSelected = true
    this.excludeSkip = true
    this.chipListComponent.clearChipElement(this.excludeChipElement, this.getProductsDataForm)
    this.chipListComponent.clearChipElement(this.alertListExcludeChipElement, this.getProductsDataForm)
    this.nextStep()
  }

  /**
   * Select all the analysis lists
   */
  public selectAllAnalysisList() {
    this.analysisSelected = true //Mark the selection as done
    this.possibleAlertsLists.forEach((alertsListsSelectElementsListGroup:selectElementsListGroup) => {
      alertsListsSelectElementsListGroup.list.forEach( alertList => {
        this.chipListComponent.addChip(alertList.value,alertList.viewValue,this.alertListAnalysisChipElement.arrayString, this.alertListAnalysisChipElement.formArrayName, this.alertListAnalysisCtrl,this.getProductsDataForm, false)
      })
    })
  }

  /**
   * When we show or hide the analysis reinitialise the analysis form part
   */
  toggleAnalysis() {
    this.analysisShowed = !this.analysisShowed

    this.chipListComponent.clearChipElement(this.inciAnalysisChipElement, this.getProductsDataForm)
    this.chipListComponent.clearChipElement(this.alertListAnalysisChipElement, this.getProductsDataForm)

  }


  /**
   * redefine a ViewChild when it is hidden or not in the HTML
   * @param input, the input to redefine
   */
  redefineViewChildInput(input:ElementRef, inputThis:ElementRef) {
    var index = this.inputElements.indexOf(inputThis)
    //Check if there is no Input defined or if the input is not the same and not included in the inputElements array
    if(input && !inputThis) { // initially setter gets called with undefined
      inputThis = input;
      this.inputElements.push(inputThis)
    } else if (index >= 0) {
      this.inputElements.splice(index, 1);
      inputThis = null
    }
  }

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.readFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.readFilesList(files);
  }

  /**
   * Go through the Files list and read their content
   * @param files (Files List)
   */
  readFilesList(files: Array<any>) {
    var that = this //In order to reference getProductsDataForm into the file reader
    for (const item of files) {
      //Make sure the file is in the JSON format
      if (item.type == "application/json"){

        //Display th loader
        this.reader.onloadstart = (e) => {
          that.openDialog()
        }

        this.reader.onload = (e) => {
          if (typeof e.target.result === "string") {
            that.eanSelected = true //Mark the step has done
            var jsonData = JSON.parse(e.target.result) //Get the data from the file
            //Add the data to the form value
            that.getProductsDataForm.value.EANs = [...that.getProductsDataForm.value.EANs, ...jsonData]
            //Get the formArray from the formBuilder
            const formArrayValues = (that.getProductsDataForm.get('EANs') as FormArray);
            //Add the data to the form control
            jsonData.forEach(data => {
              formArrayValues.push(new FormControl(data));
            })
          }
        }
        //Close the loader
        this.reader.onloadend = function(e) {
          that.dialog.closeAll()
        }
        //Read the dropped items
        this.reader.readAsText(item);
      }
    }
  }

  /**
   * Display a dialog
   */
  openDialog(): void {
    this.dialog.open(DialogLoaderComponent, {
      width: '500px',
    });

  }

  /**
   * Switch the view from basic to complex or vice versa
   * Clean all the field from the complex search when switching for complex to basic or vice versa
   */
  switchView() {
    this.basicSearch = !this.basicSearch

    this.chipListComponent.clearChipElement(this.atLeastOneChipElement, this.getProductsDataForm)
    this.chipListComponent.clearChipElement(this.alertListAtLeastOneChipElement, this.getProductsDataForm)
    this.chipListComponent.clearChipElement(this.allChipElement, this.getProductsDataForm)
    this.chipListComponent.clearChipElement(this.excludeChipElement, this.getProductsDataForm)
    this.chipListComponent.clearChipElement(this.alertListExcludeChipElement, this.getProductsDataForm)
    this.containsAtLeastOneSelected = false
    this.containsAtLeastOneSkip = false
    this.containAllSelected = false
    this.containAllSkip = false
    this.excludeSelected = false
    this.metadatas.forEach(metadata => {
      this.onChangeMetadataCheckboxes(metadata,'metadatas', {checked:false}, false)
    })
  }

  toggleEANsNotFound() {
    this.displayEANsNotFound = !this.displayEANsNotFound
  }

  /**
   * Manage the form submission
   */
  async onSubmit() {

    this.results = null
    this.getProductsDataForm.value.skip = this.skip
    //Pass the range object value into direct values to fit the api request structure
    this.getProductsDataForm.value.startDate = this.getProductsDataForm.value.range.startDate
    this.getProductsDataForm.value.endDate = this.getProductsDataForm.value.range.endDate

    var tokenData: any = await this.httpClient.post(environment.apiUrl+"temptoken", {"id":sessionStorage.getItem('id')}).toPromise()

    //a body predefined to test the request
    var bodyPredefinedForTest = {"skip":this.skip,
      "limit":0,
      "startDate":"2020-01-01",
      "endDate":"2021,01,01",
      "categories": [],
      "containAtLeastOne": {
        "INCIs":[],
        "listsIds":[]
      },
      "containAll": {
        "INCIs":[]
      },
      "exclude": {
        "INCIs":[],"listsIds":[]
      },
      "EANs":[],
      "brands":[],
      "metadatas":[],
      "countries":[],
      "analysis": {
        "listsIds":[],
        "personalList":[],
      }
    }

    //ToPromise convert an Observable to a Promise (more info here: https://blog.fullstacktraining.com/angular-promise-vs-observable/)
    var data = await this.httpClient.post(environment.apiUrl+"getProductsData",
      //bodyPredefinedForTest,
      this.getProductsDataForm.value,
      {"headers": {
          "Authorization": "Bearer " + tokenData.token,
          "Content-Type": "application/json"
        }}).toPromise()

    this.results = data
    //Define the current max and nextSkip visual variables
    if (this.results.total) {
      this.currentMax = this.skip +this.limit > this.results.total ? this.results.total : (this.skip +this.limit)
      this.nextSkip =  this.results.total - this.currentMax < this.limit ? this.results.total - this.currentMax : this.limit
    }

    // Find the EANs that are not existing or were not found
    if (this.getProductsDataForm.value.EANs.length > 0 && this.results.data){
      var resultsEANs = this.results.data.map(product => product.EAN)
      this.notFoundEAN = new MatTableDataSource(this.getProductsDataForm.value.EANs.filter(eanSearched => !resultsEANs.includes(eanSearched)))
      console.log('this.notFoundEAN', this.notFoundEAN)
    }
  }

  /**
   * Retrieve the next batch of products
   */
  getNextBatch() {
    this.skip += this.limit
    this.onSubmit()
  }
  /**
   * Retrieve the previous batch of products
   */
  getPreviousBatch() {
    this.skip -= this.limit
    this.onSubmit()
  }

}


